import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {OrganizationChart} from "primereact/organizationchart";
import axios from "axios";
import LoaderCustomFixed from "../../components/ConfirmationModal/LoaderCustomFixed";

const Structure = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const {i18n} = useTranslation();
    const currentLanguage = i18n.language
    const [organizationStructures, setOrganizationStructures] = useState([]);
    const [organizationStructuresOrgChart, setOrganizationStructuresOrgChart] = useState([null]);


    const fetchOrganizationStructures = async () => {
        try {
            const response = await axios.get(
                `${baseURL}/GetAllOrganizationStructure`
            );
            const data = response.data;
            return data.success ? data.data : [];
        } catch (error) {
            return [];
        }
    };

    useEffect(() => {
        fetchOrganizationStructures().then((data) => {
            setOrganizationStructures(data);
        });
    }, []);

    useEffect(() => {
        if (organizationStructures.length > 0) {
            organizeData();
        }
    }, [organizationStructures, i18n.language]);


    const nodeTemplate = (node) => {
        return (
            <div className="node-container">
                <div className="node-header">{node.label}</div>
                {node.fullName && (
                    <div className="node-fullname">{node.fullName}</div>
                )}

            </div>

        );

    };

    const organizeData = () => {
        const result = [];

        const nodesByLevel = [];

        organizationStructures.forEach((item) => {
            if (!nodesByLevel[item.level]) {
                nodesByLevel[item.level] = [];
            }
        });

        // Populate nodesByLevel with nodes
        organizationStructures.forEach((item) => {
            const node = {
                // className: 'p-person',
                id: item.id,
                label: currentLanguage === 'eng' ? item.nameEng : item.name,
                fullName: item.fullName,
                expanded: true,
                children: [],
            };
            nodesByLevel[item.level].push(node);
        });

        // Construct the tree
        nodesByLevel.forEach((nodes, level) => {
            nodes.forEach((node) => {
                const parentId = organizationStructures.find(
                    (item) => item.id === node.id
                ).parentId;
                if (parentId === null) {
                    result.push(node);
                } else {
                    const parentNode = nodesByLevel[level - 1].find(
                        (parent) => parent.id === parentId
                    );
                    if (parentNode) {
                        parentNode.children.push(node);
                    }
                }
            });
        });
        setOrganizationStructuresOrgChart(result);
        return result;
    };
    return (
        <div>

            {organizationStructuresOrgChart[0] ? (
                <div className="organizationchart-demo">
                    <div
                        style={{
                            width: "130px",
                            height: "130px",
                            backgroundColor: "white",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.6)",
                            margin: "0 auto 20px auto",
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/headerdata/tacsa_logo.svg"}
                            alt="Logo"
                            style={{
                                width: "100px",
                            }}
                        />
                    </div>
                    <div className="card">
                        <OrganizationChart
                            value={organizationStructuresOrgChart}
                            nodeTemplate={nodeTemplate}
                        />
                    </div>
                </div>
            ) : (
                <div style={{minHeight: 600, paddingTop: "25%", minWidth: 1098}}>
                    <LoaderCustomFixed/>
                </div>
            )}
        </div>
    );
};

export default Structure;
